export default "__VITE_ASSET__9708cb55__"